import {
  convertIExternalAPIPersonPartyDataToIExternalAPIPersonPartyResponse,
  convertIExternalAPIPersonPartyResponseToIExternalAPIPersonPartyData,
  IExternalAPIPersonPartyData,
  IExternalAPIPersonPartyResponse,
} from './IExternalAPIPersonParty';
import {
  convertIExternalAPIEntityPartyDataToIExternalAPIEntityPartyResponse,
  convertIExternalAPIEntityPartyResponseToIExternalAPIEntityPartyData,
  IExternalAPIEntityPartyData,
  IExternalAPIEntityPartyResponse,
} from './IExternalAPIEntityParty';
import { convertISignatoryDataToIPartySignatory } from '../ISignatory';
import { ePartyType } from 'ui-toolkit/enums/ePartyType';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';

export type IExternalAPIPartyResponse = IExternalAPIPersonPartyResponse | IExternalAPIEntityPartyResponse;

export type IExternalAPIPartyData = IExternalAPIPersonPartyData | IExternalAPIEntityPartyData;

export const convertIExternalAPIPartyResponseToIExternalAPIPartyData = (
  response: IExternalAPIPartyResponse
): IExternalAPIPartyData => {
  // the BE does not return party type, only entity name and entity type
  if (response.type === ePartyType.entity || !!(response as any).entity_name) {
    return convertIExternalAPIEntityPartyResponseToIExternalAPIEntityPartyData({
      ...response,
      type: ePartyType.entity,
    } as IExternalAPIEntityPartyResponse);
  } else {
    return convertIExternalAPIPersonPartyResponseToIExternalAPIPersonPartyData({
      ...response,
      type: ePartyType.person,
    });
  }
};

export const convertIExternalAPIPartyDataToIExternalAPIPartyResponse = (
  data: IExternalAPIPartyData
): IExternalAPIPartyResponse => {
  if (data.type === ePartyType.entity) {
    return convertIExternalAPIEntityPartyDataToIExternalAPIEntityPartyResponse(data);
  } else {
    return convertIExternalAPIPersonPartyDataToIExternalAPIPersonPartyResponse(data);
  }
};

export const convertIExternalAPIPartyDataToIParty = (partyData: IExternalAPIPartyData): IParty => {
  const { id, type } = partyData;
  if (type === ePartyType.entity) {
    const { entityName, entityType, signatories, purpose } = partyData;
    return {
      id: id || '',
      purpose,
      type: ePartyType.entity,
      entity_type: entityType,
      entity_name: entityName,
      signatories: (signatories || []).map(convertISignatoryDataToIPartySignatory),
    };
  } else {
    const { firstName, middleName, lastName, phoneNumber, ssn, maritalStatus, email, purpose } = partyData;
    return {
      id: id || '',
      purpose,
      type: ePartyType.person,
      first_name: firstName,
      middle_name: middleName,
      last_name: lastName,
      phone_number: phoneNumber,
      ssn,
      marital_status: maritalStatus,
      email,
    };
  }
};
